<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button class="button-purple button-text-white" (click)="scrollToTop()">
      Scroll To Top
  </button>
</div>